import { render, staticRenderFns } from "./PptPlayer.vue?vue&type=template&id=3b50b5e0"
import script from "./PptPlayer.vue?vue&type=script&lang=js"
export * from "./PptPlayer.vue?vue&type=script&lang=js"
import style0 from "./PptPlayer.vue?vue&type=style&index=0&id=3b50b5e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports